import { defineMessage } from 'react-intl';

/** Shared table column header when date and time are shown in a single column (LDateTime). */
export const gipReportResultDateTimeColumnHeaderMessage = defineMessage({
  id: 'audit.gipReport.result.dateTime',
  defaultMessage: 'Fecha/hora',
});

/** Column header for the detected match datetime on matched GIP report rows. */
export const gipReportResultMatchDateTimeColumnHeaderMessage = defineMessage({
  id: 'audit.gipReport.result.matchDateTime',
  defaultMessage: 'Fecha/hora match',
});
